import React, { useState, useEffect } from "react";
import "./SickleForm.css";
import axios from "axios"; // Import axios
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sickleAPI } from "../../../services/sickle.api";
export const handleGetRefreshToken = async (sickle_refresh_token) => {
  try {
    const response = await axios.get(
      "/nodeapi/scd/sickle-refresh-token",
      {
        headers: {
          accessToken: sickle_refresh_token,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log(error.response.data.error);
    // if (error.response.data?.error) {
    //   toast.error(error.response.data.error, {
    //     className: "custom-toast-error"
    //   });
    // }
  }
};

export const handlePatientTestDetails = async (sickle_token, data) => {
  try {
    const response = await axios.post(
      "sickle2staging/Sickle_data/PatientTestDetails",
      data,
      {
        headers: {
          Authorization: `Bearer ${sickle_token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response.data?.error) {
      toast.error(error.response.data.error, {
        className: "custom-toast-error",
      });
    }
  }
};

export const Sickleform = ({
  onSaveTest,
  patientTestDetails,
  sickleId,
  TestType,
  DiseaseType,
  onClose,
}) => {
  // State to manage mode (View or Add)
  const [viewMode, setViewMode] = useState("ADD");
  const [errors, setErrors] = useState({});
  const [PatientTestData, setPatientTestData] = useState({});
  const [lastScreening, setLastScreening] = useState(null);
  const [lastConfirmatory, setLastConfirmatory] = useState(null);
  const [showHplc, setShowHplc] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [showVendorList, setShowVendorList] = useState(false);
  const [testResultList, setTestResultList] = useState([]);
  const [testSubResultList, setTestSubResultList] = useState([]);
  const [showSubResult, setShowSubResult] = useState(false);
  const [testMethodList, settestMethodList] = useState([]);

  // State to manage form data
  const [formData, setFormData] = useState({
    testType: TestType,
    diseaseType: DiseaseType,
    testMethod: "",
    sampleCollectionDate: "",
    resultDate: "",
    testResult: "",
    test_sub_result: "",
    Test_vendor: "",
    hplcCenter: "",
    hf_state_code: "",
    hf_district_code: "",
    hf_type: "",
    hf_id: "",
  });

  // Effect to update lastScreening and lastConfirmatory when patientTestDetails changes
  useEffect(() => {
    if (patientTestDetails) {
      setLastScreening(patientTestDetails[0].last_screening);
      setLastConfirmatory(patientTestDetails[0].last_confiramatory);
    }
    setShowHplc(false);
    // Correct way to update state
    setFormData((prevData) => ({
      ...prevData,
      testType: TestType,
      diseaseType: DiseaseType,
    }));
  }, [patientTestDetails, TestType, DiseaseType]);

  // Handlers for mode change
  const handleModeChange = (mode) => {
    setViewMode(mode);
  };

  const resetAllForm = () => {
    // Correct way to update state
    setShowSubResult(false);
    setShowHplc(false);
    setShowVendorList(false);
    setFormData((prevData) => ({
      ...prevData,
      testType: TestType,
      diseaseType: DiseaseType,
      testMethod: "",
      sampleCollectionDate: "",
      resultDate: "",
      testResult: "",
      test_sub_result: "",
      Test_vendor: "",
      hplcCenter: "",
      hf_state_code: "",
      hf_district_code: "",
      hf_type: "",
      hf_id: "",
    }));
  };

  const resetForm = () => {
    // Correct way to update state
    setShowSubResult(false);
    setFormData((prevData) => ({
      ...prevData,
      sampleCollectionDate: "",
      resultDate: "",
      testResult: "",
      test_sub_result: "",
      Test_vendor: "",
      hplcCenter: "",
      hf_state_code: "",
      hf_district_code: "",
      hf_type: "",
      hf_id: "",
    }));

    setErrors((prevErrors) => ({
      ...prevErrors, // Keep existing errors
      sampleCollectionDate: "", // Clear only the specific field error
    }));
  };

  useEffect(() => {
    // console.log("update test data: ", formData);
  }, [formData]);

  // Handler for form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // Clear error for the field as the user types
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
    if (name === "testResult") {
      if (formData.testMethod === 1) {
        if (value === 1) {
          setShowHplc(false);
          setShowSubResult(false);
        } else if (value === 2) {
          setShowHplc(true);
          setShowSubResult(false);
        }
      } else if (formData.testMethod === 4) {
        if (value === 1) {
          setShowHplc(false);
          setShowSubResult(false);
        } else if (value === 3) {
          setShowSubResult(true);
        } else if (value === 4) {
          setShowSubResult(true);
        }
      } else if (formData.testMethod === 6 || formData.testMethod === 5) {
        if (value === 1) {
          setShowHplc(false);
          setShowSubResult(false);
        } else if (value === 3) {
          setShowSubResult(true);
        } else if (value === 4) {
          setShowSubResult(true);
        }
      } else if (formData.testMethod === 2 || formData.testMethod === 3) {
        if (value === 1) {
          setShowHplc(false);
          setShowSubResult(false);
        } else if (value === 2) {
          setShowHplc(true);
          setShowSubResult(false);
        }
      }
    } else if (name === "testMethod") {
      resetForm();
      setErrors(validateReset());
      if (value === 4) {
        setShowVendorList(true);
      } else if (value !== 4) {
        setShowVendorList(false);
      }
    }
  };

  // Validate input fields
  const validateReset = () => {
    const newErrors = {};

    newErrors.sampleCollectionDate = "";
    newErrors.resultDate = "";
    newErrors.testResult = "";
    newErrors.Test_vendor = "";
    newErrors.hplcCenter = "";
    return newErrors;
  };

  // Validate input fields
  const validate = () => {
    const newErrors = {};
    if (!formData.testType) {
      newErrors.testType = "Test type is required";
    }

    if (!formData.diseaseType) {
      newErrors.diseaseType = "Disease type is required";
    }

    if (!formData.testMethod.trim()) {
      newErrors.testMethod = "Test Method is required";
    }

    if (!formData.sampleCollectionDate.trim() && !showVendorList) {
      newErrors.sampleCollectionDate = "Sample collection date is required";
    }

    if (!formData.resultDate.trim() && !showVendorList) {
      newErrors.resultDate = "Result date is required";
    }

    if (!formData.testResult.trim()) {
      newErrors.testResult = "Test result is required";
    }

    if (
      !formData.test_sub_result.trim() &&
      formData.testResult !== 1 &&
      formData.testResult !== 2
    ) {
      newErrors.test_sub_result = "Test sub result is required";
    }

    if (!formData.Test_vendor.trim() && showVendorList) {
      newErrors.Test_vendor = "Test vendor is required";
    }

    if (!formData.hplcCenter.trim() && showHplc) {
      newErrors.hplcCenter = "Hplc center is required";
    }

    return newErrors;
  };

  useEffect(() => {
    /**
     * This method is used to be get vendor list
     */
    const vendorTestMethod = async () => {
      try {
        const response = await axios.get(
          "sickle2staging/Master_data2/vendorTestMethod"
        );
        if (response.data?.ResultType) {
          setVendorList(response.data.ResultType);
        }
      } catch (error) {
        if (error.response.data?.error) {
          toast.error(error.response.data.error, {
            className: "custom-toast-error",
          });
        }
      }
    };
    vendorTestMethod();
    /**
     * This method is used to be get test result
     */
    const testResult = async () => {
      try {
        const response = await axios.get(
          "sickle2staging/Master_data2/testResult"
        );
        if (response.data?.ResultType) {
          setTestResultList(response.data.ResultType);
        }
      } catch (error) {
        if (error.response.data?.error) {
          toast.error(error.response.data.error, {
            className: "custom-toast-error",
          });
        }
      }
    };
    testResult();
    /**
     * This method is used to be get test sub result
     */
    const testSubResult = async () => {
      try {
        const response = await axios.get(
          "sickle2staging/Master_data2/testSubResult"
        );
        if (response.data?.ResultType) {
          setTestSubResultList(response.data.ResultType);
        }
      } catch (error) {
        if (error.response.data?.error) {
          toast.error(error.response.data.error, {
            className: "custom-toast-error",
          });
        }
      }
    };
    testSubResult();

    /**
     * This method is used to be get test method
     */
    const testMethod = async () => {
      try {
        const response = await axios.get(
          "sickle2staging/Master_data2/testMethod"
        );
        if (response.data?.ResultType) {
          settestMethodList(response.data.ResultType);
        }
      } catch (error) {
        if (error.response.data?.error) {
          toast.error(error.response.data.error, {
            className: "custom-toast-error",
          });
        }
      }
    };
    testMethod();
  }, []);

  useEffect(() => {
    const loggedinUserdetails = JSON.parse(
      localStorage.getItem("loggedinUserdetails")
    );
    setPatientTestData({
      patient_test_data: [
        {
          sickle_id: sickleId ? sickleId : "",
          disease_type: formData.diseaseType ? formData.diseaseType : "",
          Test_type: formData.testType ? formData.testType : "",
          test_method: formData.testMethod ? formData.testMethod : "",
          Test_vendor: formData.Test_vendor ? formData.Test_vendor : "",
          Test_result: formData.testResult ? formData.testResult : "",
          test_sub_result: formData.test_sub_result
            ? formData.test_sub_result
            : "",
          samplecollection_date: formData.sampleCollectionDate
            ? formData.sampleCollectionDate
            : "",
          ResultDate: formData.resultDate ? formData.resultDate : "",
          hplc_testing_center: formData.hplcCenter ? formData.hplcCenter : "",
          InchargeMobile: loggedinUserdetails.InchargeMobile
            ? loggedinUserdetails.InchargeMobile
            : "",
          hf_state_code: formData.hf_state_code ? formData.hf_state_code : "",
          hf_district_code: formData.hf_district_code
            ? formData.hf_state_code
            : "",
          hf_type: formData.hf_type ? formData.hf_type : "",
          hf_id: formData.hf_id ? formData : "",
        },
      ],
    });
  }, [sickleId, formData]);

  // Handler for Save button
  const handleSave = async (e) => {
    e.preventDefault();
    const formErrors = validate();
    if (Object.keys(formErrors).length === 0) {
      setIsLoading(true);
      try {
        const responseSaveTestData = await sickleAPI.savePatientTestDetails(
          PatientTestData
        );
        if (responseSaveTestData[0]?.Status === 200) {
          onSaveTest();
          resetAllForm();
          toast.success(responseSaveTestData[0]?.Message);
          setIsLoading(false);
          setViewMode("VIEW");
        } else {
          setIsLoading(false);
          setViewMode("VIEW");
          toast.error(responseSaveTestData[0]?.Message);
        }
      } catch (error) {
        console.error("Error in healthIdMapping:", error);
      }
    } else {
      // Set errors to display them to the user
      setErrors(formErrors);
    }
  };

  const formatDate = (dateInput) => {
    if (!dateInput) return "N/A";

    // Convert input to a Date object
    const date = new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date.getTime())) return "Invalid Date";

    // Extract day, month, and year
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <>
      
      <div className="row">
        {/* <div className="col-md-3"></div> */}
        <div className="col-md-12 col-lg-12 col-xs-12 col-12">
          <div className="sickle-form Sickle-form-section p-4">
            {/* Header with View and Add buttons */}
            <div className="d-flex  align-items-center mb-4">
              <div className="d-flex align-items-center gap-2">
                <img
                  src={"/images/Sickel.svg"}
                  alt="Sickle Cell Icon"
                  style={{ width: "43px", margin: "10px 0 0 0" }}
                />
                <h4
                  className="Header_accordian mb-0"
                  id="screening-form-section"
                >
                  Sickle Cell Screening
                </h4>
              </div>

              <div className="mode-toggle  ms-auto">
                <button
                  className={`mode-btn left-btn ${
                    viewMode === "VIEW" ? "active" : ""
                  }`}
                  onClick={() => handleModeChange("VIEW")}
                >
                  View
                </button>
                <button
                  className={`mode-btn right_btn ${
                    viewMode === "ADD" ? "active" : ""
                  }`}
                  onClick={() => handleModeChange("ADD")}
                >
                  Add
                </button>
              </div>
              <div
                className="closeDive sickleclosediv closeDiveNcdForm ms-3"
                onClick={() => onClose("handleCloseSickleForm")}
              >
                <img src={"/images/closing.svg"} alt="Close" />
              </div>
            </div>
            {viewMode === "VIEW" && (
              <>
                <div className="viewSectionAll">
                  <>
                    <h5>Screening Test</h5>
                    <div className="sectionStepView">
                      {lastScreening && (
                        <div>
                          <table className="table table-bordered rounded-table">
                            <thead className="sicle-custom-table">
                              <tr>
                                <th>Test Type</th>
                                <th>Test for Disease Type</th>

                                <th>Test Method</th>
                                {lastScreening.vendor_name && (
                                  <th>Vendor Name</th>
                                )}
                                {lastScreening.samplecollection_date && (
                                  <th>Date of Sample Collection</th>
                                )}
                                {lastScreening.ResultDate && (
                                  <th>Date of Result</th>
                                )}
                                <th>Test Result</th>
                                {lastScreening.subresult_name && (
                                  <th>Test Sub Result</th>
                                )}
                                {lastScreening.hplc_testing_center && (
                                  <th>Referred to HPLC Centre</th>
                                )}
                              </tr>
                            </thead>
                            <tbody className="td-sickle-row">
                              <tr>
                                <td>{lastScreening.test_name}</td>
                                <td>{lastScreening.disease_name}</td>
                                <td>{lastScreening.method_name}</td>
                                {lastScreening.vendor_name && (
                                  <td>
                                    {formatDate(lastScreening.vendor_name)}
                                  </td>
                                )}
                                {lastScreening.samplecollection_date && (
                                  <td>
                                    {formatDate(
                                      lastScreening.samplecollection_date
                                    )}
                                  </td>
                                )}
                                {lastScreening.ResultDate && (
                                  <td>
                                    {formatDate(lastScreening.ResultDate)}
                                  </td>
                                )}
                                <td>{lastScreening.result_name}</td>
                                {lastScreening.subresult_name && (
                                  <td>{lastScreening.subresult_name}</td>
                                )}
                                {lastScreening.hplc_testing_center && (
                                  <td>{lastScreening.hplc_testing_center}</td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      )}
                      {!lastScreening && (
                        <div className="col-md-12 text-center">
                          <>
                            <p>No Record Found</p>
                          </>
                        </div>
                      )}
                    </div>
                  </>
                  <h5>Confirmatory Test</h5>
                  <div className="sectionStepView">
                    {lastConfirmatory && (
                      <>
                        <div className="table-responsive">
                          <table className="table table-bordered rounded-table">
                            <thead className="sicle-custom-table">
                              <tr>
                                <th>Test for Disease Type</th>
                                <th>Test Type</th>
                                <th>Test Method</th>
                                {lastConfirmatory.vendor_name && (
                                  <th>Vendor Name</th>
                                )}
                                {lastConfirmatory.samplecollection_date !==
                                  "0000-00-00" && (
                                  <th>Date of Sample Collection</th>
                                )}
                                {lastConfirmatory.ResultDate !==
                                  "0000-00-00 00:00:00" && (
                                  <th>Date of Result</th>
                                )}
                                <th>Test Result</th>
                                {lastConfirmatory.subresult_name && (
                                  <th>Test Sub Result</th>
                                )}
                                {lastConfirmatory.hplc_testing_center && (
                                  <th>Referred to HPLC Centre</th>
                                )}
                              </tr>
                            </thead>
                            <tbody className="td-sickle-row">
                              <tr>
                                <td>{lastConfirmatory.disease_name}</td>
                                <td>{lastConfirmatory.test_name}</td>
                                <td>{lastConfirmatory.method_name}</td>
                                {lastConfirmatory.vendor_name && (
                                  <td>{lastConfirmatory.vendor_name}</td>
                                )}
                                {lastConfirmatory.samplecollection_date !==
                                  "0000-00-00" && (
                                  <td>
                                    {formatDate(
                                      lastConfirmatory.samplecollection_date
                                    )}
                                  </td>
                                )}
                                {lastConfirmatory.ResultDate !==
                                  "0000-00-00 00:00:00" && (
                                  <td>
                                    {formatDate(lastConfirmatory.ResultDate)}
                                  </td>
                                )}
                                <td>{lastConfirmatory.result_name}</td>
                                {lastConfirmatory.subresult_name && (
                                  <td>{lastConfirmatory.subresult_name}</td>
                                )}
                                {lastConfirmatory.hplc_testing_center && (
                                  <td>
                                    {lastConfirmatory.hplc_testing_center}
                                  </td>
                                )}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                    {!lastConfirmatory && (
                      <div className="col-md-12 text-center">
                        <>
                          <p>No Record Found</p>
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {viewMode === "ADD" && (
              <>
                {/* Form */}
                <form>
                  {/* First Row */}
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="diseaseType" className="form-label">
                        Test for Disease Type{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div
                        className="dropdown-wrapper"
                        style={{ "pointer-events": "none" }}
                      >
                        <select
                          name="diseaseType"
                          className="form-control form-drop dropdown-icon"
                          id="diseaseType"
                          value={formData.diseaseType}
                          onChange={handleChange}
                        >
                          <option value="">Select Disease Type</option>
                          <option value="1">Sickle</option>
                          <option value="2" disabled>
                            Thalassemia
                          </option>
                          <option value="3" disabled>
                            Other Variant
                          </option>
                        </select>
                      </div>
                      {errors.diseaseType && (
                        <p style={{ color: "red" }}>{errors.diseaseType}</p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="testType" className="form-label">
                        Test Type <span className="text-danger">*</span>
                      </label>
                      <div
                        className="dropdown-wrapper"
                        style={{ "pointer-events": "none" }}
                      >
                        <select
                          name="testType"
                          className="form-control form-drop dropdown-icon"
                          id="testType"
                          value={formData.testType}
                          onChange={handleChange}
                        >
                          <option value="">Select Test Type</option>
                          <option value="1">Screening</option>
                          <option value="2">Confirmatory</option>
                        </select>
                      </div>
                      {errors.testType && (
                        <p style={{ color: "red" }}>{errors.testType}</p>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="testMethod" className="form-label">
                        Test Method <span className="text-danger">*</span>
                      </label>
                      <div className="dropdown-wrapper">
                        <select
                          name="testMethod"
                          className="form-control form-drop dropdown-icon"
                          id="testMethod"
                          value={formData.testMethod}
                          onChange={handleChange}
                        >
                          <option value="">Select Method</option>
                          {testMethodList
                            .filter(
                              (item) =>
                                (item.method_code === 1 &&
                                  formData.testType === item.test_code &&
                                  formData.diseaseType === 1) ||
                                (item.method_code === 2 &&
                                  formData.testType === item.test_code &&
                                  formData.diseaseType === 2) ||
                                (item.method_code === 3 &&
                                  formData.testType === item.test_code &&
                                  formData.diseaseType === 2) ||
                                (item.method_code === 4 &&
                                  formData.testType === item.test_code &&
                                  formData.diseaseType === 1) ||
                                (item.method_code === 5 &&
                                  (formData.testType === item.test_code ||
                                    (formData.testType === "" &&
                                      formData.diseaseType === 3)) &&
                                  (formData.diseaseType === 1 ||
                                    formData.diseaseType === 2 ||
                                    formData.diseaseType === 3)) ||
                                (item.method_code === 6 &&
                                  (formData.testType === item.test_code ||
                                    (formData.testType === "" &&
                                      formData.diseaseType === 3)) &&
                                  (formData.diseaseType === 1 ||
                                    formData.diseaseType === 2 ||
                                    formData.diseaseType === 3))
                            )
                            .map((item) => (
                              <option value={item.method_code}>
                                {item.method_name}
                              </option>
                            ))}
                        </select>
                      </div>
                      {errors.testMethod && (
                        <p style={{ color: "red" }}>{errors.testMethod}</p>
                      )}
                    </div>
                  </div>

                  {/* Second Row */}
                  <div className="row mb-3">
                    {!showVendorList && (
                      <>
                        <div className="col-md-4">
                          <label
                            htmlFor="sampleCollectionDate"
                            className="form-label"
                          >
                            Date of Sample Collection{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            name="sampleCollectionDate"
                            className="form-control bottom-border"
                            id="sampleCollectionDate"
                            value={formData.sampleCollectionDate}
                            onChange={handleChange}
                            max={new Date().toISOString().split("T")[0]}
                          />
                          {errors.sampleCollectionDate && (
                            <p style={{ color: "red" }}>
                              {errors.sampleCollectionDate}
                            </p>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label htmlFor="resultDate" className="form-label">
                            Date of Result{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="date"
                            name="resultDate"
                            className="form-control bottom-border"
                            id="resultDate"
                            value={formData.resultDate}
                            onChange={handleChange}
                            max={new Date().toISOString().split("T")[0]}
                          />
                          {errors.resultDate && (
                            <p style={{ color: "red" }}>{errors.resultDate}</p>
                          )}
                        </div>
                      </>
                    )}
                    {showVendorList && (
                      <div className="col-md-4">
                        <label htmlFor="testResult" className="form-label">
                          Test Vendor <span className="text-danger">*</span>
                        </label>
                        <div className="dropdown-wrapper">
                          <select
                            name="Test_vendor"
                            className="form-control form-drop dropdown-icon"
                            id="Test_vendor"
                            value={formData.Test_vendor}
                            onChange={handleChange}
                          >
                            <option value="">Select Vendor</option>
                            {vendorList.map((item) => (
                              <option value={item.vendor_code}>
                                {item.vendor_name}
                              </option>
                            ))}
                          </select>
                        </div>
                        {errors.Test_vendor && (
                          <p style={{ color: "red" }}>{errors.Test_vendor}</p>
                        )}
                      </div>
                    )}
                    <div className="col-md-4">
                      <label htmlFor="testResult" className="form-label">
                        Test Result <span className="text-danger">*</span>
                      </label>
                      <div className="dropdown-wrapper">
                        <select
                          name="testResult"
                          className="form-control form-drop dropdown-icon"
                          id="testResult"
                          value={formData.testResult}
                          onChange={handleChange}
                        >
                          <option value="">Select Result</option>
                          {testResultList
                            .filter(
                              (item) =>
                                (item.result_code === 1 &&
                                  formData.testMethod !== "" &&
                                  formData.diseaseType !== 3) ||
                                (item.result_code === 2 &&
                                  (formData.testMethod === 1 ||
                                    formData.testMethod === 2 ||
                                    formData.testMethod === 3)) ||
                                (item.result_code === 3 &&
                                  (formData.testMethod === 4 ||
                                    formData.testMethod === 5 ||
                                    formData.testMethod === 6)) ||
                                (item.result_code === 4 &&
                                  (formData.testMethod === 4 ||
                                    formData.testMethod === 5 ||
                                    formData.testMethod === 6))
                            )
                            .map((item) => (
                              <option
                                key={item.result_code}
                                value={item.result_code}
                              >
                                {item.result_name}
                              </option>
                            ))}
                        </select>
                      </div>
                      {errors.testResult && (
                        <p style={{ color: "red" }}>{errors.testResult}</p>
                      )}
                    </div>

                    {showSubResult && (
                      <>
                        <div className="col-md-4">
                          <label htmlFor="mapping_id" className="form-label">
                            Test Sub Result{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="dropdown-wrapper">
                            <select
                              name="test_sub_result"
                              className="form-control form-drop dropdown-icon"
                              id="test_sub_result"
                              value={formData.test_sub_result}
                              onChange={handleChange}
                              // style={{ 'pointer-events': 'none' }}
                            >
                              <option value="">Select Sub Result</option>
                              {testSubResultList
                                .filter(
                                  (item) =>
                                    (item.subresult_code === 8 &&
                                      formData.diseaseType === 1 &&
                                      ((formData.testMethod === 4 &&
                                        formData.testResult === 4) ||
                                        (formData.testMethod === 5 &&
                                          formData.testResult === 4) ||
                                        (formData.testMethod === 6 &&
                                          formData.testResult === 4))) ||
                                    (item.subresult_code === 3 &&
                                      formData.diseaseType === 1 &&
                                      ((formData.testMethod === 4 &&
                                        formData.testResult === 3) ||
                                        (formData.testMethod === 5 &&
                                          formData.testResult === 3) ||
                                        (formData.testMethod === 6 &&
                                          formData.testResult === 3))) ||
                                    (item.subresult_code === 16 &&
                                      formData.diseaseType === 2 &&
                                      ((formData.testMethod === 5 &&
                                        formData.testResult === 3) ||
                                        (formData.testMethod === 6 &&
                                          formData.testResult === 3))) ||
                                    (item.subresult_code === 17 &&
                                      formData.diseaseType === 2 &&
                                      ((formData.testMethod === 5 &&
                                        formData.testResult === 4) ||
                                        (formData.testMethod === 6 &&
                                          formData.testResult === 4))) ||
                                    (item.subresult_code === 18 &&
                                      formData.diseaseType === 2 &&
                                      ((formData.testMethod === 5 &&
                                        formData.testResult === 4) ||
                                        (formData.testMethod === 6 &&
                                          formData.testResult === 4))) ||
                                    (item.subresult_code === 19 &&
                                      formData.diseaseType === 2 &&
                                      ((formData.testMethod === 5 &&
                                        formData.testResult === 4) ||
                                        (formData.testMethod === 6 &&
                                          formData.testResult === 4))) ||
                                    (item.subresult_code === 20 &&
                                      formData.diseaseType === 3) ||
                                    (item.subresult_code === 21 &&
                                      formData.diseaseType === 3) ||
                                    (item.subresult_code === 24 &&
                                      formData.diseaseType === 3)
                                )
                                .map((item) => (
                                  <option
                                    key={item.subresult_code}
                                    value={item.subresult_code}
                                  >
                                    {item.subresult_name}
                                  </option>
                                ))}
                            </select>
                          </div>
                          {errors.test_sub_result && (
                            <p style={{ color: "red" }}>
                              {errors.test_sub_result}
                            </p>
                          )}
                        </div>
                      </>
                    )}
                  </div>

                  {/* Third Row */}
                  {showHplc && (
                    <div className="row mb-4">
                      <div className="col-md-4">
                        <label className="form-label">
                          Referred to HPLC Centre
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="hplcCenter"
                          className="form-control bottom-border"
                          id="hplcCenter"
                          value={formData.hplcCenter}
                          onChange={handleChange}
                          autoComplete="off"
                        />
                      </div>
                      {errors.hplcCenter && (
                        <p style={{ color: "red" }}>{errors.hplcCenter}</p>
                      )}
                    </div>
                  )}

                  <div className="text-end">
                    <button
                      type="submit"
                      className="btn btn-success"
                      onClick={handleSave}
                    >
                      {IsLoading ? "Processing..." : "Save"}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Sickleform;
